import React from 'react';
import './Cali.css'; 

const Guabito = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><p className='Guabito'>Base aérea Marco Fidel Suarez</p></h1>
    </div>
    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 07</th>                      
          </tr>   
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/ULQ1H.pdf" target="_blank" rel="noreferrer">ULQ1H</a></th>
          </tr>    
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/ISOP1D.pdf" target="_blank" rel="noreferrer">ISOP1D</a></th>
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/ISOP1D.pdf" target="_blank" rel="noreferrer">PPN1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/ISOP1D.pdf" target="_blank" rel="noreferrer">MONV1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/SIGI1D.pdf" target="_blank" rel="noreferrer">SIGI1D</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/SIGI1D.pdf" target="_blank" rel="noreferrer">ULQ1J</a></th>
          </tr>

          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 25</th>                      
          </tr>   
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/ISOP1D.pdf" target="_blank" rel="noreferrer">ISOP1D</a></th>
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/ISOP1D.pdf" target="_blank" rel="noreferrer">PPN1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/ISOP1D.pdf" target="_blank" rel="noreferrer">MONV1C</a></th>
          </tr>   
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/SIGI1D.pdf" target="_blank" rel="noreferrer">SIGI1D</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/SIGI1D.pdf" target="_blank" rel="noreferrer">ULQ1J</a></th>
          </tr>       
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 07</th>                      
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 25</th>                      
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 07</th>                      
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 25</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/VORA25.pdf" target="_blank" rel="noreferrer">VOR A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/RNPZ25.pdf" target="_blank" rel="noreferrer">RNP Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKGB/RNPY25.pdf" target="_blank" rel="noreferrer">RNP Y</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Guabito;